import { useTranslation } from 'react-i18next';
import { BotAvatar } from './BotAvatar';

/**
 * Static welcome greeting displayed as the first message in the OptiBot chat.
 * Styled as an assistant (left-aligned) message bubble with bot avatar.
 */
export function WelcomeMessage() {
  const { t } = useTranslation();

  return (
    <div className="flex items-start gap-2">
      <BotAvatar />
      <div className="max-w-[85%] rounded-lg bg-card px-4 py-2.5 text-sm text-card-foreground shadow-sm">
        {t('optibot.welcome')}
      </div>
    </div>
  );
}
